<template lang="html">
  <div id="route-type-box" class="row" v-if="showRouteTypes">
    <div id="route-type-car-btn" class="route-type-select col-4" @click="selectRouteType($event, 'car')" tabindex="0">
      <span class="material-icons" aria-hidden="true">directions_car</span>
      <div id="route-type-car-text" class="route-type-text">Bil</div>
    </div>
    <div id="route-type-bike-btn" class="route-type-select col-4" @click="selectRouteType($event, 'bike')" tabindex="0">
      <span class="material-icons" aria-hidden="true">directions_bike</span>
      <div id="route-type-bike-text" class="route-type-text">Cykel</div>
    </div>
    <div id="route-type-pedestrian-btn" class="route-type-select col-4" @click="selectRouteType($event, 'pedestrian')" tabindex="0">
      <span class="material-icons" aria-hidden="true">directions_walk</span>
      <div id="route-type-pedestrian-text" class="route-type-text">Fodgænger</div>
    </div>
    <!--Bike sub types-->
    <div id="route-type-bike-box" class="col-12 no-pad-both" v-show="showBikeRouteTypes">
      <div class="route-type-select col-3" id="bikeRecommendedSelect" @click="selectRouteType($event, 'bike', 'bikeRecommended')" tabindex="0">
        <div class="svg" aria-hidden="true"></div>
        <div class="bike-route-type-text">Anbefalet</div>
      </div>
      <div class="route-type-select col-3" id="bikeShortestSelect" @click="selectRouteType($event, 'bike', 'bikeShortest')" tabindex="0">
        <span class="text-icon" aria-hidden="true">A - B</span>
        <div class="bike-route-type-text" style="top: 6px;">Korteste</div>
      </div>
      <div class="route-type-select col-3" id="bikeNightSelect" @click="selectRouteType($event, 'bike', 'bikeNight')" tabindex="0">
        <div class="svg" aria-hidden="true"></div>
        <div class="bike-route-type-text">21 - 09</div>
      </div>
      <div class="route-type-select col-3" id="bikeGreenSelect" @click="selectRouteType($event, 'bike', 'bikeGreen')" tabindex="0">
        <div class="svg" aria-hidden="true"></div>
        <div class="bike-route-type-text">Grøn</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showBikeRouteTypes: false,
      previousSelectedBikeType: undefined
    }
  },
  props: {
    showRouteTypes: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    selectRouteType(event, routeType, routeSubType) {
      this.showBikeRouteTypes = (routeType == 'bike') ? true : false;

  		if(routeSubType == undefined) {
        document.getElementsByClassName('route-type-select').forEach(el => el.classList.remove('route-type-select-active'));
        event.currentTarget.classList.add('route-type-select-active');
  		}

      if(routeType == 'bike') {
        document.getElementsByClassName('route-type-select').forEach(el => el.classList.remove('bike-type-select-active'));

  			if(routeSubType != undefined) {
          event.currentTarget.classList.add('bike-type-select-active');
          this.previousSelectedBikeType = routeSubType;
  			}
  			else {
  				routeSubType = this.previousSelectedBikeType != undefined ? this.previousSelectedBikeType : 'bikeRecommended';
  				document.getElementById(routeSubType+'Select').classList.add('bike-type-select-active');
          event.currentTarget.classList.add('route-type-select-active');
  			}
  		}
      this.$emit('routeTypeSelected', routeType, routeSubType);
    },
  },
}
</script>

<style lang="css" scoped>
  #route-type-box {
    position: relative;
    height: auto;
    border-top: 1px solid #dedede;
    overflow: hidden;
    -moz-transition: height 0.5s ease;
    -webkit-transition: height 0.5s ease;
    -o-transition: height 0.5s ease;
    transition: height 0.5s ease;
  }

  #route-type-bike-box {
    position: relative;
    padding-top: 5px;
  }

  #route-type-box.expanded {
    height: 40px;
  }

  .route-type-select {
    display: inline-block;
    position: relative;
    height: 100%;
    text-align: center;
    margin: 0;
    padding: 0px;
    text-shadow: 1px 1px #eee;
    cursor: pointer;
  }

  .route-type-select-active {
    border-bottom: 3px solid rgb(0,112,141);
  }

  .bike-type-select-active {
    color: #f8f8f8;
    text-shadow: none;
  }

  .route-type-select .material-icons {
    position: relative;
    top: 4px;
  }

  .route-type-select .svg {
    display: inline-block;
    position: relative;
    top: 5px;
    height: 20px;
    width: 20px;
    background-repeat: no-repeat;
  }

  .text-icon {
    position: relative;
    top: 5px;
    height: 20px;
    font-size: 18px;
    font-weight: 700;
  }

  .route-type-text, .bike-route-type-text {
    font-size: 12px !important;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
  }

  .route-type-text {
    top: -2px;
  }

  .route-type-select .material-icons {
    font-size: 20px !important;
  }

  /*Colors for icons*/
  #route-type-car-btn.route-type-select-active .material-icons {
    color: #a7172b;
  }

  #route-type-car-btn i {
    color: #b09094;
  }

  #route-type-bike-btn.route-type-select-active .material-icons {
    color: #00708d;
  }

  #route-type-bike-btn i {
    color: #7fa6b1;
  }

  #route-type-pedestrian-btn.route-type-select-active .material-icons {
    color: #ffdc00;
  }

  #route-type-pedestrian-btn .material-icons {
    color: #ccc48f;
  }

  /* Bike recommended*/
  #bikeRecommendedSelect.bike-type-select-active {
    background-color: #00708d;
    color: #f8f8f8;
  }

  #bikeRecommendedSelect.bike-type-select-active .svg {
    background-image: url('~@/assets/img/cykel_anbefalet_white.svg');
  }

  #bikeRecommendedSelect .svg {
    background-image: url('~@/assets/img/cykel_anbefalet.svg');
  }

  /*Bike shortest colors*/
  #bikeShortestSelect.bike-type-select-active {
    background-color: #0096ce;
  }

  #bikeShortestSelect.bike-type-select-active span {
    color: #f8f8f8;
  }

  #bikeShortestSelect span {
    color: #0096ce;
  }

  /*Bike night time colors*/
  #bikeNightSelect.bike-type-select-active {
    background-color: #002e5e;
    color: #f8f8f8;
  }

  #bikeNightSelect.bike-type-select-active .svg {
    background-image: url('~@/assets/img/cykel_nat_white.svg');
  }

  #bikeNightSelect .svg {
    background-image: url('~@/assets/img/cykel_nat.svg');
  }

  /*Bike green route colors*/
  #bikeGreenSelect.bike-type-select-active {
    background-color: #00643f;
    color: #f8f8f8;
  }

  #bikeGreenSelect.bike-type-select-active .svg {
    background-image: url('~@/assets/img/cykel_groen_white.svg');
  }

  #bikeGreenSelect .svg {
    background-image: url('~@/assets/img/cykel_groen.svg');
  }
</style>
